export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"stylesheet","href":"https://use.typekit.net/rha6qoo.css"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"charset":"utf-8"},{"name":"description","content":"Universidade Comunitária da Região de Chapecó - Unochapecó."},{"name":"robots","content":"index, follow"},{"name":"author","content":"Unochapecó"},{"name":"keywords","content":"Vestibular sc, Vestibular santa catarina, Vestibular chapeco, Vestiba, Unochapeco, Universidade sc, Universidade santa catarina, Universidade comunitaria chapeco, Universidade comunitaria, Universidade chapeco, Seletivo sc, Seletivo santa catarina, Seletivo chapeco, Ies sc, Ies santa catarina, Ies chapeco, Ies, Graduacao santa catarina, Graduacao chapeco, Graduacao, Financiamento estudantil, Faculdade sc, Faculdade santa catarina, Faculdade chapeco, Faculdade, Ensino superior sc, Ensino superior santa catarina, Ensino superior chapeco, Ensino superior, Ead chapeco, Ead, Chapeco "},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"pt-BR"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1.0","title":"Portal - Unochapecó"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true